import * as React from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Cookies from "cookies-js";
import { withRouter, Prompt } from 'react-router';
import AdalTokenRefresh from "./common/AdalTokenRefresh";

// Our stuff under here
import SignalRListener from "./SignalR/SignalRListener";
//import DataRefresh from "./common/DataRefresh";
import DataSync from "./common/DataSync";
import InstaDocTokenRefresh from "./common/InstaDocTokenRefresh";
import MobileAppBanner from "./common/MobileAppBanner";
import MobileAppDownload from "./common/MobileAppDownload";
import VersionUpdateBanner from "./common/VersionUpdateBanner";
import HistoryBinder from "./common/HistoryBinder";
import EnsureLoggedIn from "./common/EnsureLoggedIn";
import Header from "./header/Header";
import HeaderLoggedOut from "./header/HeaderLoggedOut";
import Footer from "./common/footer/Footer";
import FooterLoggedOut from "./common/footer/FooterLoggedOut";

import RoutePortal from "./common/RoutePortal";
import RoutePortalLoggedIn from "./common/RoutePortalLoggedIn";
import RouteLoggedIn from "./common/RouteLoggedIn";
import * as Tools from "../helpers/Tools";
import VideoVisitTips from './common/footer/VideoVisitTips';

// Route specific components
import Dashboard from "./dashboard/Dashboard";
import HelpTutorials from "./settings/HelpTutorials";
import Home from "./home/Home";
import Login from "./login/login";
import ForgotUsername from "./login/ForgotUsername";
import ForgotPassword from "./login/ForgotPassword";
import ResetPassword from "./login/ResetPassword";
import NavigateParent from "./common/navigateParent";
import Notifications from "./settings/Notifications";
import ResetTest from "./common/ResetTest";
import Settings from "./settings/Settings";
import TermsAgreement from "./login/TermsAgreement";
import WhatsNew from "./settings/WhatsNew";

import RegisterGAHit from "../helpers/GoogleAnalyticsAPI";
import { logUI } from "../api/andyliticsApi";
import SystemCrash from "../components/common/SystemCrash";
import SystemOutage from "../components/common/SystemOutage";

import CriticalUpdateModal from "../components/common/CriticalUpdateModal";
import * as types from "../constants/actionTypes";
import * as msgs from "../constants/textConstants";
import AppointmentMenu from "../components/appointments/AppointmentMenu";

import Spinner from "./common/spinner";
import ServiceDownBanner from './common/ServiceDownBanner';
import AmbulatoryCareVideoVisit from "../components/care/AmbulatoryCareVideoVisit";
import AmbulatorySurvey from "../components/care/AmbulatorySurvey";
import ErrorPage from "./common/ErrorPage";
import PageNotFound from "./common/PageNotFound";

export class AppRoutes extends React.Component {

    static getDerivedStateFromError(error) {
        //debugger;
        return { hasError: true };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            hadError: false,
            isDataLoaded: false
        };

        this.logHit = this.logHit.bind(this);
        this.getMobileBanner = this.getMobileBanner.bind(this);
        if (typeof window !== "undefined") {
            this.logHit();
        }
        this.criticalUpdateAvailable = false;
        this.isNewAppVersionAvailable = false;
    }

    componentDidMount() {
        if (this.props.isLoggedIn && this.props.location.pathname === "/login") {
            // Snap off the login page before rednering
            //debugger;
            this.props.history.push("/");
        }

        this.historyUnlisten = this.props.history.listen((location, action) => {
            if (location.pathname === this.props.history.location.pathname) {
                window.formChanged = false;
                if (window.isMyChartPage) {
                    this.props.forceReload();
                }
            }
        });

        //this.unblock = this.props.history.block((location, action) => {
        //    if (window.formChanged || window.componentChanged) {
        //        //debugger;
        //        return "Would you like to leave this page and lose changes?";
        //    }
        //});

        this.updateDataLoaded();
    }

    componentDidUpdate(prevProps) {
        ////Bug 31395: Back button navigation on Dashboard loads the login page next to Navigation bar.
        //if (this.props.isLoggedIn && this.props.location && this.props.location.pathname === "/login") {
        //    this.props.history.push("/");
        //}

        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (typeof window !== "undefined") {
                window.scrollTo(0, 0);

                this.logHit();
            }
            window.componentChanged = false;
            window.formChanged = false;
        }
        if (this.props.location.pathname !== prevProps.location.pathname) {
            if (this.state.hasError) {
                this.setState({ hasError: false });
            }
        }

        this.updateDataLoaded();
    }

    componentWillUnmount() {
        window.formChanged = false;
        window.componentChanged = false;
        if (this.state.hasError) {
            this.setState({ hasError: false });
        }
        if (this.historyUnlisten) {
            this.historyUnlisten();
        }
        //if (this.unblock) {
        //    this.unblock();
        //    this.unblock = null;
        //}
    }

    logHit() {
        try {
            // trackPageView doesn't work, but start/stop does
            //window.appInsights.trackPageView();
            //window.ai.flush();
            //debugger;
            const locpathname = this.props.location.pathname;
            const path = locpathname.replace('/', '.').split('/').join('.').split('-').join('.').split(':').join('.');
            const action = locpathname.replace("/", ".").split('/').length > 0 ? locpathname.replace("/", ".").split('/')[0] : '';
            const actCode = locpathname === "/" ? '.Dashboard' : action;
            logUI("MBHWeb.Event.Route" + actCode, new Date(), this.props.location.href, '', path);
            //debugger;
            window.appInsights.startTrackPage();
            window.appInsights.stopTrackPage();
            RegisterGAHit(window.document.title, this.props.location.href);
        }
        catch (e) {
            //debugger;
        }
    }


    componentDidCatch(error, info) {
        //debugger;
        console.error(error, info);
        this.setState({ hasError: true });
        let json = { error: error, componentStack: info };
        let errorJson = error ? { errorMessage: error.message ? error.message : null, errorStack: error.stack ? error.stack : null } : {}; //If we pass directly error object, it won't convert. So doing parsing this way.
        //logUI("MBHWeb.Event.Route.Exception", new Date(), null, JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(errorJson), JSON.stringify(info));
    }

    getMobileBanner = (serverData, isFromMobile, isMobileRedirect) => {
        if (typeof window === "undefined") {
            return null;
        }
        else {
            const NO_REDIRECT = 'noredirect'; // cookie to prevent redirect
            let isAndroid = Tools.isAndroid();
            let isIos = Tools.isIos();
            let isIPad = Tools.isIPad();
            const IS_MOBILE = 'isMobile';
            let isRegistration = Tools.isRegistrationQuery(this.props.location) && this.props.location.pathname === "/terms"; //special case handled here to check the redirection is from registration application for terms.
            const isResetPassword = this.props.location.pathname.toLowerCase() === "/resetpassword";
            let showBanner = !Cookies.get(NO_REDIRECT) && (!isIPad && (isAndroid || isIos)) && !isFromMobile && !isMobileRedirect && !isRegistration && !Tools.getItemFromSessionStorage(IS_MOBILE) && !isResetPassword; // if noredirect is not stamped and either android or iOS device then showMobileBanner
            // if already skipped and mobilePromptExpirationInDays not exceeded
            if (showBanner) {
                logUI("MBHWeb.Event.ShowMobileBanner", new Date(), this.props.location && this.props.location.pathname, JSON.stringify({ isAndroid: isAndroid, isIos: isIos, isIPad: isIPad, showBanner: showBanner }));
                return (
                    <MobileAppBanner
                        key={showBanner}
                        showBanner={showBanner}
                        mobilePromptExpirationInDays={serverData.mobilePromptExpirationInDays}
                        ssoBaseURL={serverData.ssoBaseURL}
                        isAndroid={isAndroid}
                        isIos={isIos}
                        redirectUrl={this.props.location}
                        careOptions={serverData.careOptions}
                    />);
            }
        }
    }

    updateDataLoaded = () => {
        const isDataLoaded = this.mainContainer && this.mainContainer.offsetHeight > 96;

        if (this.state.isDataLoaded !== isDataLoaded) {
            this.setState({ isDataLoaded });
        }
    }

    render() {
        const { isServerside, location, MobileOnQueryString, isSwitchingProxy } = this.props;
        const { isLoggedIn, hasMyChart, hasPharmacy, serverData, menuItems, appUpdate, applicationVersion, normalAppUpdateShow, onLogoutClick } = this.props;
        const isReset = location.pathname === "/reset";
        let mobileClass = "";
        const IS_MOBILE = 'isMobile';
        const showAssistanceLink = location.pathname === "/linkedaccounts" || location.pathname === "/linkeddevices" || location.pathname === "/loginsettings";
        const showVersionUpdateBanner = this.isNewAppVersionAvailable && normalAppUpdateShow === true && this.criticalUpdateAvailable === false;
        const showServiceDownBanner = hasMyChart && serverData && serverData.bundle.toLowerCase() === "mybswhealth" && serverData.epicEHRDown;
        //const videoVisitEnabled = serverData ? serverData.ambulatoryVideoVisitEnabled : false;

        //debugger;
        if (applicationVersion && appUpdate && appUpdate.response && appUpdate.response.minappversion && this.minappversion !== appUpdate.response.minappversion) {
            this.minappversion = appUpdate.response.minappversion;
            this.criticalUpdateAvailable = Tools.isNewerVersion(applicationVersion, appUpdate.response.minappversion) ? true : false;
        }

        if (this.state.hasError) {
            return <SystemCrash />;
        }

        if (appUpdate && appUpdate.response && appUpdate.response.siteoutage === true) {
            if (isLoggedIn) {
                onLogoutClick();
            }
            return <SystemOutage />;
        }

        //Task 36112: Mobile App: Don't Show Marketing APP download banner if they have mobile=true in query params. We are handling this only for inside mobile app, due to hiding header and footer.
        //if (Tools.isMobileQuery(location)) {

        //}
        const isFromMobile = MobileOnQueryString || Tools.isMobileQuery(location) || Tools.getItemFromSessionStorage(IS_MOBILE); // Tools.isMobileQuery(location); //getting the params from search value of location as we cannot have params at this level for specific comp.    

        //Setting to session storage if we have mobile value.
        if (isFromMobile && !Tools.getItemFromSessionStorage(IS_MOBILE)) {
            Tools.setItemToSessionStorage(IS_MOBILE, true);
        } else if (Tools.isMobileQueryDisabled(location) && Tools.getItemFromSessionStorage(IS_MOBILE)) {
            Tools.clearItemFromSessionStorage(IS_MOBILE);
        }

        const isMobileRedirect = location.pathname === "/download";
        if (applicationVersion && appUpdate && appUpdate.response && appUpdate.response.appVersion && this.appversion !== appUpdate.response.appVersion && this.criticalUpdateAvailable === false) {
            this.appversion = appUpdate.response.appVersion;
            this.isNewAppVersionAvailable = Tools.isNewerVersion(applicationVersion, appUpdate.response.appVersion) ? true : false;
        }

        //DOWNLOAD APP THAT DIRECTS USER TO CORRESPONDING APP STORE TO DOWNLOAD APP    
        if (isMobileRedirect) {
            let isAndroid = Tools.isAndroid();
            let isIos = Tools.isIos();
            let isIPad = Tools.isIPad();
            this.GOOGLE_PLAY_URL = `${serverData.ssoBaseURL}app_download/android`;
            this.IPHONE_APP_URL = `${serverData.ssoBaseURL}app_download/iphone`;
            if (isIos || isIPad) {
                if (typeof window !== 'undefined')
                    window.location.href = this.IPHONE_APP_URL;
                logUI('MBHWeb.MobileApp.iTunes.Redirect', new Date(), '/iTunesDownload');
                return null;
            }
            else if (isAndroid) {
                if (typeof window !== 'undefined')
                    window.location.href = this.GOOGLE_PLAY_URL;
                logUI('MBHWeb.MobileApp.GooglePlay.Redirect', new Date(), '/GooglePlayDownload');
                return null;
            }
        }

        if (hasPharmacy && (serverData.bundle.toLowerCase() === "pharmacy" || location.pathname.indexOf('/pharmacy') > -1)) {
            mobileClass = isFromMobile ? "bswh-rx bswh-mobile" : "bswh-rx";
        }
        else {
            mobileClass = isFromMobile ? "bswh-mobile" : null;
        }

        //Temp fix to handle multiple redirects from mobile app web view.
        //if (isFromMobile && (location.pathname === "/" || location.pathname === "/login")) {
        //    return <Spinner />;
        //}

        //Temp fix to handle multiple redirects from mobile app web view.
        if (isFromMobile) {
            if (isLoggedIn && (location.pathname === "/" || location.pathname === "/login")) {
                return <Spinner />;
            } else if (!isLoggedIn && (location.pathname === "/login")) {
                //if token is not good, then showing error message if user loading in mobile app web view.
                return <div className={mobileClass}><ErrorPage heading="We're unable to proceed and may need to reload your session." subBannerMsg={"Please try again."} /></div>;
            }
        }

        const hideApptMenu = location && location.pathname === "/providersurvey" ? true : false;

        return (
            <div className={mobileClass} ref={el => this.mainContainer = el}>
                <HistoryBinder />
                <DataSync />
                {/*<DataRefresh />*/}
                <AdalTokenRefresh />
                <InstaDocTokenRefresh />
                <SignalRListener />
                {!isServerside && <EnsureLoggedIn attributeIdleTimeoutSeconds={serverData.idleTimeoutSeconds} attributeIdleTimeoutCountdownSeconds={serverData.idleTimeoutCountdownSeconds} />}
                {(isLoggedIn && !isReset && location.pathname !== "/acceptterms" && location.pathname !== "/captureinsurance" && !isFromMobile) ?
                    <React.Fragment>
                        <Header serverData={serverData} />
                        <AppointmentMenu hideApptMenu={hideApptMenu} />

                        {showVersionUpdateBanner && showServiceDownBanner ?
                            <VersionUpdateBanner message="Medical records are down for maintenance. However, an update is available for other parts of MyBSWHealth." />
                            : showVersionUpdateBanner && !showServiceDownBanner ? <VersionUpdateBanner message={serverData.versionUpdateMessage} /> :
                                !showVersionUpdateBanner && showServiceDownBanner ? <ServiceDownBanner className="service-down-banner" message="Medical records are down for maintenance. Please try again later." />
                                    : null
                        }
                    </React.Fragment>
                    :
                    ((location.pathname === "/terms" ||
                        location.pathname === "/payasguest" ||
                        location.pathname === "/download") && !isFromMobile)
                        ?
                        <HeaderLoggedOut />
                        : ""
                }
                {isSwitchingProxy && <Spinner />}
                <Switch>
                    {/*this.getMobileBanner(serverData, isFromMobile, isMobileRedirect)*/}

                    {this.criticalUpdateAvailable && <CriticalUpdateModal counterValue={serverData.criticalUpdateCouterValue} />}
                    <RoutePortal exact path="/login" component={Login} serverData={serverData} title="Sign In to BSW Virtual" />

                    <RoutePortal exact path="/forgotusername" component={ForgotUsername} serverData={serverData} title="Forgot Username" />
                    <RoutePortal exact path="/forgotpassword" component={ForgotPassword} serverData={serverData} title="Forgot Password" />
                    <RoutePortal exact path="/resetpassword" component={ResetPassword} serverData={serverData} title="Reset Password" />
                    {/*<RoutePortal exact path="/mycaretasks" component={CareCoach} title="Care Coach" />*/}
                    {/*<RoutePortal exact path="/carecoach" component={CareCoach} title="Care Coach" />*/}
                    <RoutePortal exact path="/download" component={MobileAppDownload} title="Download MyBSWHealth Mobile App" />
                    <RoutePortalLoggedIn exact path="/acceptterms" component={TermsAgreement} title="Terms and Conditions Acceptance" />

                    <Route exact path="/reset" component={NavigateParent} title="" />
                    <Route exact path="/resettest" component={ResetTest} title="" />
                    <RoutePortalLoggedIn exact path="/" component={Dashboard} title="Home" />
                    <RoutePortalLoggedIn exact path="/home" component={Home} title="Home" />
                    <RoutePortalLoggedIn path="/settings" component={Settings} title="Settings" />
                    <RoutePortalLoggedIn path="/videovisittips" component={VideoVisitTips} title="Helpful Video Tips" />

                    {serverData && serverData.manageProviderMobileNoInSettings && <RoutePortalLoggedIn path="/notifications" component={Notifications} title="Notifications" />}

                    <RouteLoggedIn path="/whatsnew" component={WhatsNew} title="What's New" />
                    <RoutePortalLoggedIn path="/help" component={HelpTutorials} title="Help and Tutorials" />

                    {serverData && serverData.enableVisitHistory && <RoutePortalLoggedIn path="/providervideovisit/history/:departmentid?/:providerid?" component={AmbulatoryCareVideoVisit} title="Video Visit" />}
                    <RoutePortalLoggedIn path="/providervideovisit/:csnId?/:sameDayCare?" component={AmbulatoryCareVideoVisit} title="Video Visit" />
                    <RoutePortalLoggedIn path="/patientvideovisit/:csnId?" component={AmbulatoryCareVideoVisit} title="Video Visit" />
                    <RoutePortalLoggedIn path="/providersurvey" component={AmbulatorySurvey} title="Video Visit Survey" />

                    <RoutePortal path="/pagenotfound" component={PageNotFound} />

                    {isLoggedIn ?
                        (isFromMobile) ? <Redirect to="/pagenotfound" /> : <Redirect to="/" /> : <Redirect to="/login" />}

                </Switch>

                {(isLoggedIn && !isReset && !isFromMobile)
                    ? (location.pathname !== "/acceptterms" && location.pathname !== "/captureinsurance") ?
                        <Footer showAssistanceLink={showAssistanceLink} fixBottom={this.state.isDataLoaded ? "" : "footer-sticky-bottom"} />
                        : <FooterLoggedOut />
                    : ((location.pathname === "/terms" ||
                        location.pathname === "/disclosures" ||
                        location.pathname === "/login" ||
                        location.pathname === "/forgotusername" ||
                        location.pathname === "/forgotpassword" ||
                        location.pathname === "/resetpassword" ||
                        location.pathname === "/download"
                    )) ? <FooterLoggedOut />
                        : ""
                }
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        isEmployee: state.domain.ie,
        serverData: state.session.serverData,
        menuItems: state.session.serverData ? state.session.serverData.activeMenuItems : null,
        appUpdate: state.common[types.GET_APP_UPDATE],
        applicationVersion: state.session.serverData ? state.session.serverData.applicationVersion : "1.0.0.0",
        normalAppUpdateShow: state.header.normalAppUpdateShow,
        MobileOnQueryString: state.domain.mq,
        isSwitchingProxy: state.header.switchingProxyUser,
        isModuleCrash: state.common.hideBannerOnCrash,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage }),
        forceReload: () => dispatch({ type: types.RELOAD_KEY })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppRoutes));